var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"editPrototype"},[_c('color-text-btn',{on:{"click":function($event){return _vm.goInfoPage('edit')}}},[_vm._v(" 编辑 ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }